import { components } from '@kurtosys/ksys-app-components';
import { IComponentConfiguration } from '@kurtosys/ksys-app-components/dist/models/IComponentConfiguration.js';
const Button = components.base.Button.Button;
const Card = components.base.Card.Card;
const Text = components.base.Text.Text;
const FactList = components.fact.FactList.FactList;

export const LIBRARY_COMPONENTS_CONFIGURATION: IComponentConfiguration = {
	base: {
		grid: {
			components: {
				'base.button': {
					key: 'base.button',
					component: Button,
				},
				'base.card': {
					key: 'base.card',
					component: Card,
				},
				'base.text': {
					key: 'base.text',
					component: Text,
				},
				'fact.factList': {
					key: 'fact.factList',
					component: FactList,
				},
				'product.list': {
					key: 'product.list',
					component: FactList,
				},
				'chargesAndInvesting.list': {
					key: 'product.list',
					component: FactList,
				},
				'srri.list': {
					key: 'srri.list',
					component: FactList,
				},
				'priceAndYield.list': {
					key: 'priceAndYield.list',
					component: FactList,
				},
				'identifiers.list': {
					key: 'identifiers.list',
					component: FactList,
				},
				'distributionDates.list': {
					key: 'distributionDate.list',
					component: FactList,
				},
			},
		},
	},
};
